export default {
  getTranslations(locale) {
    switch (locale) {
      case 'sr-Latn':
        return import(/* webpackChunkName: "sr-Latn" */ './sr-Latn');
      case 'tr':
        return import(/* webpackChunkName: "tr" */ './tr');
      case 'hr':
        return import(/* webpackChunkName: "hr" */ './hr');
      default:
        return import(/* webpackChunkName: "i18n.en" */ './en');
    }
  },
  checkLocale(locale) {
    switch (locale) {
      case 'sr':
        return 'sr-Latn';
      default:
        return locale;
    }
  },
};
